import { colors } from '../../theme/colors'

export const ColorsConstants = {
  defaultSequentialPattern: 'sequential.default' as const,
  defaultSemanticPattern: 'semantic.default' as const,
  defaultContrastRatio: 3,
  /** Default series highlight (hovered point outline). */
  defaultHighlight: colors.presets.neutral['0'],
}
